'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResultsCarousel = exports.CAROUSEL_SELECTOR = exports.CONTAINER_SELECTOR = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CarouselSection2 = require('./../../sections/carousel/CarouselSection');

var _ShopifySection = require('./../../sections/ShopifySection');

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-results-carousel]'; /*
                                                                                  *  Results Carousel
                                                                                  *    Carousel of results using Slick.
                                                                                  *
                                                                                  *  Version:
                                                                                  *    1.0.0 - 2020/05/18
                                                                                  */

var CAROUSEL_SELECTOR = exports.CAROUSEL_SELECTOR = '[data-results-carousel-carousel]';

var ResultsCarousel = exports.ResultsCarousel = function (_CarouselSection) {
  (0, _inherits3.default)(ResultsCarousel, _CarouselSection);

  function ResultsCarousel(container) {
    (0, _classCallCheck3.default)(this, ResultsCarousel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ResultsCarousel.__proto__ || Object.getPrototypeOf(ResultsCarousel)).call(this, container));

    _this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    _this.slick = _this.initCarousel(_this.carouselContainer);
    return _this;
  }

  (0, _createClass3.default)(ResultsCarousel, [{
    key: 'optionOverrides',
    value: function optionOverrides() {
      var _ref;

      return _ref = {
        infinite: this.container.data('infinite') === true ? true : false,
        autoplay: this.container.data('autoplay') == true,
        autoplaySpeed: this.container.data('autoplay-speed') * 1000 || 5000,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }, (0, _defineProperty3.default)(_ref, 'arrows', false), (0, _defineProperty3.default)(_ref, 'adaptiveHeight', true), (0, _defineProperty3.default)(_ref, 'arrows', true), (0, _defineProperty3.default)(_ref, 'nextArrow', this.container.find(_CarouselSection2.NEXT_SELECTOR)), (0, _defineProperty3.default)(_ref, 'prevArrow', this.container.find(_CarouselSection2.PREV_SELECTOR)), (0, _defineProperty3.default)(_ref, 'responsive', [{
        breakpoint: ResponsiveSizes.small - 1,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: ResponsiveSizes.medium - 1,
        settings: {
          slidesToShow: 3
        }
      }]), _ref;
    }
  }]);
  return ResultsCarousel;
}(_CarouselSection2.CarouselSection);

(0, _ShopifySection.register)(CONTAINER_SELECTOR, ResultsCarousel);